import en from "./en/translation.json";
import cs from "./cs/translation.json";
import pl from "./pl/translation.json";

export const Translations = {
  /** English */
  en,
  /** Czech */
  cs,
  /** Polish / Polski */
  pl,
};

export type TranslationName = keyof typeof Translations;
